import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { ISettingTypeState } from 'src/app/modules/siteSettings/components/settings'

const checkMultiLanguage = () => {
  const [isMultiLanguage, setIsMultiLanguage] = useState<boolean>(false)
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Multi Language Settings']?.map((item: any) => {
          if (item?.name === 'hideMultiLanguage') {
            let data = item?.value === '1' ? true : false
            setIsMultiLanguage(data)
          }
        })
    }
  }, [settingTypeData])
  return isMultiLanguage
}

export default checkMultiLanguage
